import { render, staticRenderFns } from "./Signiture.vue?vue&type=template&id=16c6083b&scoped=true&"
import script from "./Signiture.vue?vue&type=script&lang=ts&"
export * from "./Signiture.vue?vue&type=script&lang=ts&"
import style0 from "./Signiture.vue?vue&type=style&index=0&id=16c6083b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c6083b",
  null
  
)

export default component.exports